import React from 'react';
import { useMeetingContext } from 'src/context/MeetingProvider';
import { RecommendedPath } from 'types';

const PostInterviewComponent = () => {
	const { predictedUserSalary, recommendedUserPath } = useMeetingContext();

	return (
		<div className="p-6 rounded-[8px] border border-solid border-[#c7c9d91a]">
			{predictedUserSalary ? (
				<div className="text-xl font-bold">
					Predicted Salary: <span>{`${predictedUserSalary.min}-${predictedUserSalary.max} LPA`}</span>
				</div>
			) : null}
			{recommendedUserPath ? (
				<>
					<div className="mt-3 text-xl font-bold">
						Recommended Path:{' '}
						<span>
							{recommendedUserPath && recommendedUserPath === RecommendedPath.MAP ? (
								<> Masai Career Launchpad</>
							) : (
								recommendedUserPath
							)}
						</span>
					</div>
					{recommendedUserPath === RecommendedPath.JAP ? (
						<div>
							<p>Please ensure to convey the following message after discussing scores in brief:</p>
							<p>- Interviewee is in the top 10% of LevelUp aspirants</p>
							<p>- Interviewee is eligible for an assured job program within their forecasted salary in 45 days</p>
						</div>
					) : recommendedUserPath === RecommendedPath.PrepPlan ? (
						<div>
							<p>Please ensure to convey the following message after discussing scores in brief:</p>
							<p>- Interviewee requires basic improvements which can result in improving their scores</p>
							<p>
								- Once the prep plan is completed, the interviewee can schedule the same round again to see improved
								scores
							</p>
						</div>
					) : recommendedUserPath === RecommendedPath.MAP ? (
						<div>
							<p>Please ensure to convey the following message after discussing scores in brief:</p>
							<p>- Interviewee is in the top 10% of LevelUp aspirants</p>
							<p>
								- Interviewee is eligible for sitting in Masai placements directly without going through the rigourous 6
								month course. Briefly mention the success of Masai's hiring partners and placement stats
							</p>
							<p>
								- Masai has 4500+ students placed, 4200+ hiring partners, 91% placement rate, highest ctc: 36 LPA,
								average ctc: 6.9 LPA
							</p>
						</div>
					) : (
						<div>
							<p>Please ensure to convey the following message after discussing scores in brief:</p>
							<p>- Interviewee has to upskill and might not be eligible for job opportunities immediately</p>
							<p>
								- Interviewee can book a 1-1 counselling session after the interview to get detailed feedback about the
								interview. Based on the call, the counsellor would give further suggestions
							</p>
						</div>
					)}
				</>
			) : null}
		</div>
	);
};

export default PostInterviewComponent;
